export const formatName = (string) => {
  return string
    .trim()
    .replace(/["~!@#$%^&*()'_+=`{}[]|\\:;'<>,.\/?"- \t\r\n]+/g, "")
    .replace(/\s+/g, "-")
    .toLowerCase();
};
